import { dispatch } from '@angular-redux/store';
import { BaseAction } from './baseAction';

export class dialogCreationActions {
    static readonly SET_NEW_PLAN_DIALOG_OPEN = 'SET_NEW_PLAN_DIALOG_OPEN';

    // Write to the redux store dashboardSectionId
    @dispatch()
    public static setNewPlanDialogOpen(newPlanDialogOpen: boolean): BaseAction {
        return { type: this.SET_NEW_PLAN_DIALOG_OPEN, payload: newPlanDialogOpen };
    }
}
